import { Injectable } from '@angular/core';
import { generateClient } from 'aws-amplify/api';
import * as queries from '@graphql/queries';
import * as mutations from '@graphql/mutations';
import {
    UpdateProductoInput,
    Producto,
    CreateProductoInput
} from '@app/core/services/api/API.service';

@Injectable({
    providedIn: 'root'
})
export class ProductService {
    private amplifyClient = generateClient();

    constructor() {}

    async listProductos(): Promise<Producto[]> {
        try {
            const response = await this.amplifyClient.graphql({
                query: queries.listProductos
            });

            if (response.errors) {
                console.error('GraphQL errors:', response.errors);
                throw new Error('Error al consultar productos');
            }

            const data = response.data.listProductos.items;
            if (data) return data as Producto[];

            console.warn('No se encontraron productos');
            return [];
        } catch (error) {
            // console.error('Error finding ExternalApis:', error);
            return [];
        }
    }

    async getProducto(id: string): Promise<Producto> {
        try {
            const data = (
                await this.amplifyClient.graphql({
                    query: queries.getProducto,
                    variables: {
                        id
                    }
                })
            ).data.getProducto;
            if (data) return data as Producto;
        } catch (error) {
            console.error('Error finding ExternalApis:', error);
            return null;
        }
    }

    async productsByAutoAllowed(isAutoAllowed: string): Promise<Producto[]> {
        try {
            const data = (
                await this.amplifyClient.graphql({
                    query: queries.productsByAutoAllowed,
                    variables: {
                        isAutoAllowed
                    }
                })
            ).data.productsByAutoAllowed.items;
            if (data) return data as Producto[];
        } catch (error) {
            console.error('Error product:', error);
            return null;
        }
    }

    async productsByProviderStatus(providerId: string): Promise<Producto[]> {
        try {
            const data = (
                await this.amplifyClient.graphql({
                    query: queries.productsByProviderStatus,
                    variables: {
                        providerId
                    }
                })
            ).data.productsByProviderStatus.items;
            if (data) return data as Producto[];
        } catch (error) {
            console.error('Error product:', error);
            return null;
        }
    }

    async productsByProviderCategory(providerId: string): Promise<Producto[]> {
        try {
            const data = (
                await this.amplifyClient.graphql({
                    query: queries.productsByProviderCategory,
                    variables: {
                        providerId
                    }
                })
            ).data.productsByProviderCategory.items;
            if (data) return data as Producto[];
        } catch (error) {
            console.error('Error product:', error);
            return null;
        }
    }

    async productsByCategory(categoryId: string): Promise<Producto[]> {
        try {
            const response = await this.amplifyClient.graphql({
                query: queries.productsByCategory,
                variables: {
                    categoryId
                }
            });
            const data = response.data.productsByCategory.items;
            if (data) {
                return data as Producto[];
            }
            return [];
        } catch (error) {
            console.error('Error al obtener productos por categoría:', error);
            return [];
        }
    }

    async productsByCategoryPrice(categoryId: string): Promise<Producto[]> {
        try {
            const data = (
                await this.amplifyClient.graphql({
                    query: queries.productsByCategoryPrice,
                    variables: {
                        categoryId
                    }
                })
            ).data.productsByCategoryPrice.items;
            if (data) return data as Producto[];
        } catch (error) {
            console.error('Error product:', error);
            return null;
        }
    }

    async productsByCategoryProviderPrice(
        categoryId: string
    ): Promise<Producto[]> {
        try {
            const data = (
                await this.amplifyClient.graphql({
                    query: queries.ProductsByCategoryProviderPrice,
                    variables: {
                        categoryId
                    }
                })
            ).data.ProductsByCategoryProviderPrice.items;
            if (data) return data as Producto[];
        } catch (error) {
            console.error('Error product:', error);
            return null;
        }
    }

    async productsByBestSellers(bestSeller: string): Promise<Producto[]> {
        try {
            const data = (
                await this.amplifyClient.graphql({
                    query: queries.productsByBestSellers,
                    variables: {
                        bestSeller
                    }
                })
            ).data.productsByBestSellers.items;
            if (data) return data as Producto[];
        } catch (error) {
            console.error('Error product:', error);
            return null;
        }
    }
    async productBySku(sku: string): Promise<Producto[]> {
        try {
            const data = (
                await this.amplifyClient.graphql({
                    query: queries.productBySku,
                    variables: {
                        sku
                    }
                })
            ).data.productBySku.items;
            if (data) return data as Producto[];
        } catch (error) {
            console.error('Error product:', error);
            return null;
        }
    }

    async ProductsByName(name: string): Promise<Producto[]> {
        try {
            const data = (
                await this.amplifyClient.graphql({
                    query: queries.ProductsByName,
                    variables: {
                        name
                    }
                })
            ).data.ProductsByName.items;
            if (data) return data as Producto[];
        } catch (error) {
            console.error('Error product:', error);
            return null;
        }
    }

    async createProducto(input: CreateProductoInput): Promise<Producto> {
        try {
            const product = (
                await this.amplifyClient.graphql({
                    query: mutations.createProducto,
                    variables: {
                        input
                    }
                })
            ).data.createProducto;
            if (product) return product as Producto;
        } catch (error) {
            console.error('Error creating product:', error);
            return null;
        }
    }

    async updateProducto(input: UpdateProductoInput): Promise<Producto> {
        try {
            const product = (
                await this.amplifyClient.graphql({
                    query: mutations.updateProducto,
                    variables: {
                        input
                    }
                })
            ).data.updateProducto;
            if (product) return product as Producto;
        } catch (error) {
            console.error('Error updating product:', error);
            return null;
        }
    }
}
